import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { TextControl } from '../../Controls';

const PROP_NAME = 'subAgentName';

class SubmitOnBehalfOfInput extends PureComponent {
  constructor() {
    super();

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    lockedState: PropTypes.bool,
    disabledState: PropTypes.bool,
    id: PropTypes.string,
  };

  static defaultProps = {
    lockedState: false,
    disabledState: false,
  };

  handleOnChange(value) {
    this.props.onChange((value || '').substr(0, 50), PROP_NAME);
  }

  render() {
    const { value, lockedState, disabledState, id } = this.props;

    return (
      <div className="sobo-component">
        <TextControl
          {...{ lockedState, disabledState, value }}
          id={id}
          label="msg_enter_sub_agent_name"
          onChange={this.handleOnChange}
        />
      </div>
    );
  }
}

export default SubmitOnBehalfOfInput;
